import { Button } from 'components/common';

interface IProps {
  text: string;
  className?: string;
  style?: React.CSSProperties;
  params?: any;
}

const StandardFleetConnect = ({
  text,
  className,
  style,
  params,
}: IProps) => {
  const handleConnect = () => {
    const baseUrl = `${process.env.REACT_APP_STANDARD_FLEET_URI}&redirect_uri=${process.env.REACT_APP_STANDARD_FLEET_REDIRECT_URI}`;

    if (params && Object.keys(params).length > 0) {
      const url = new URL(baseUrl);

      Object.entries(params).forEach(([key, value]) => {
        url.searchParams.append(key, String(value));
      });

      window.open(url.toString(), '_blank');
    } else {
      window.open(baseUrl, '_blank');
    }
  };

  return (
    <Button
      onClick={handleConnect}
      className={className}
      style={{ ...style }}
    >
      {text}
    </Button>
  );
};

export default StandardFleetConnect;
